export const OBSERVACAO_MAX_LENGTH = 900

export const observacaoFields = [
    {
        key: "observacao",
        label: "Observação",
        md: 12,
        type: "dynamicTextarea",
        longText: true,
        maxLength: OBSERVACAO_MAX_LENGTH,
        minRows: 3,
        maxRows: 8,
        defaultValue: null,
        inputProps: {
            placeholder: "Informações adicionais relevantes sobre os parâmetros.",
        },
    },
]